/* oxlint-disable typescript/no-non-null-assertion -- intentional null assertions */
// Process ==marked text==
// Like strikethrough but for highlighting/marking text
// Also supports ==color=marked text== for colored marks

import type { Delimiter } from '../state-inline'
import type StateInline from '../state-inline'

// Insert `mark` tokenizer into `ruler` before `emphasis`
function tokenize(state: StateInline, silent: boolean): boolean {
  const start = state.pos
  const marker = state.src.charCodeAt(start)

  if (silent) return false

  if (marker !== 0x3d /* = */) return false

  const scanned = state.scanDelims(state.pos, true)
  let len = scanned.length
  const ch = String.fromCharCode(marker)

  if (len < 2) return false

  // Only process pairs of == (not single =)
  let token
  if (len % 2) {
    token = state.push('text', '', 0)
    token.content = ch
    len--
  }

  for (let i = 0; i < len; i += 2) {
    token = state.push('text', '', 0)
    token.content = ch + ch

    state.delimiters.push({
      marker,
      length: 0, // disable "rule of 3" length checks meant for emphasis
      token: state.tokens.length - 1,
      end: -1,
      open: scanned.can_open,
      close: scanned.can_close,
    })
  }

  state.pos += scanned.length

  return true
}

function postProcess(state: StateInline, delimiters: Delimiter[]): void {
  const _loneMarkers = []
  const max = delimiters.length

  for (let i = 0; i < max; i++) {
    const startDelim = delimiters[i]

    if (startDelim.marker !== 0x3d /* = */) continue

    if (startDelim.end === -1) continue

    const endDelim = delimiters[startDelim.end]
    const token_open = state.tokens[startDelim.token]
    const token_close = state.tokens[endDelim.token]

    // Check if there's a color prefix (e.g., ==red=text==)
    const content = token_open.content
    const colorMatch = content.match(/^==([a-zA-Z0-9_-]+)=$/)

    token_open.type = 'mark_open'
    token_open.tag = 'mark'
    token_open.nesting = 1
    token_open.markup = '=='
    token_open.content = ''

    token_close.type = 'mark_close'
    token_close.tag = 'mark'
    token_close.nesting = -1
    token_close.markup = '=='
    token_close.content = ''

    if (colorMatch) {
      // Colored mark: ==color=text==
      token_open.attrs = [['class', `mark-${colorMatch[1]}`]]
    }
  }
}

// Walk through delimiter list and replace text tokens with tags
function mark_postProcess(state: StateInline): void {
  const tokens_meta = state.tokens_meta
  const max = state.tokens_meta.length

  postProcess(state, state.delimiters)

  for (let curr = 0; curr < max; curr++) {
    const delimiters = tokens_meta[curr]?.delimiters
    if (delimiters) {
      postProcess(state, delimiters)
    }
  }
}

export default {
  tokenize,
  postProcess: mark_postProcess,
}
